var _circle, _path, _path2, _g, _circle2, _g2, _g3, _g4, _circle3, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrenada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ffda44",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m111.713 44.522c41.085-28.086 90.763-44.522 144.287-44.522s103.202 16.436 144.287 44.522l-144.287 11.13z",
    fill: "#a2001d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m256 256-16.338-16.338-4.338 7.771z",
    fill: "#0052b4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#496e2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m74.98 74.98c-99.974 99.974-99.974 262.065 0 362.04 41.313-41.313 81.046-81.046 181.02-181.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.02 74.98c99.974 99.974 99.974 262.065 0 362.04-41.313-41.313-81.046-81.046-181.02-181.02z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#a2001d",
    r: 89.043
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m255.999 166.957 19.959 61.429h64.598l-52.258 37.973 19.959 61.432-52.258-37.966-52.26 37.966 19.963-61.432-52.258-37.973h64.594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-.029 0-.057.002-.086.002h.171c-.028 0-.056-.002-.085-.002z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#a2001d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.086 0h-.171c-70.653.023-134.614 28.666-180.921 74.968h362.013c-46.308-46.302-110.269-74.945-180.921-74.968z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.995 437.033c46.326 46.319 110.32 74.967 181.005 74.967s134.679-28.648 181.005-74.967z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 27.826 4.145 12.754h13.41l-10.849 7.883 4.145 12.754-10.851-7.882-10.849 7.882 4.145-12.754-10.851-7.883h13.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.923 27.826 4.145 12.754h13.41l-10.849 7.883 4.145 12.754-10.851-7.882-10.848 7.882 4.144-12.754-10.851-7.883h13.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.077 27.826 4.145 12.754h13.41l-10.849 7.883 4.145 12.754-10.851-7.882-10.849 7.882 4.145-12.754-10.851-7.883h13.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 450.783 4.145 12.754h13.41l-10.849 7.883 4.145 12.754-10.851-7.883-10.849 7.883 4.145-12.754-10.851-7.883h13.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.923 450.783 4.145 12.754h13.41l-10.849 7.883 4.145 12.754-10.851-7.883-10.848 7.883 4.144-12.754-10.851-7.883h13.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.077 450.783 4.145 12.754h13.41l-10.849 7.883 4.145 12.754-10.851-7.883-10.849 7.883 4.145-12.754-10.851-7.883h13.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.003 251.772c6.575 10.389 3.485 24.14-6.904 30.716-10.388 6.576-24.14 3.486-30.716-6.903-11.905-18.808-5.002-49.525-5.002-49.525s30.716 6.903 42.622 25.712z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.146,
    cy: 273.085,
    fill: "#a2001d",
    r: 11.13
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrenada);
export default __webpack_public_path__ + "static/media/grenada.4dc83578220fa388df232a3d6951fa01.svg";
export { ForwardRef as ReactComponent };